import React, { Component, PropTypes } from 'react';

class ColorPicker extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <label className="spark-input color-picker-input">
                    <textarea
                        className="spark-input__field"
                        placeholder="#FFEEDD"
                        rows="1"
                        maxLength="6"
                        spellCheck={false}
                        role="textbox"
                        value={this.props.color.substr(1)}
                        onChange={this.props.onColorChange}
                    />
                    <div className="spark-input__addon">
                        <i className="spark-icon-design-dropper spark-icon--md">
                            <input
                                className="color-picker-selector"
                                type="color"
                                value={this.props.color}
                                onChange={this.props.onColorChange}
                            />
                        </i>
                    </div>
                </label>
            </div>
        );
    }
}

ColorPicker.propTypes = {
    color: PropTypes.string,
    onColorChange: PropTypes.func,
    className: PropTypes.string
};

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/widgets/ColorPicker.js